import { CheckIcon } from '@heroicons/react/20/solid'

const features = [
	{
		name: 'Extensive Question Database',
		description:
			'Our question bank features various question types like multiple choice and short answer, all categorized by difficulty to suit learners at any stage.',
	},
	{
		name: 'Expert-Curated Content',
		description:
			'Our questions are meticulously crafted and reviewed by educational experts.',
	},
	{
		name: 'Flexible Pricing Plans',
		description:
			'From startups to large enterprises, we offer a range of plans designed to meet your needs and scale with your growth.',
	},
	{
		name: 'Dedicated Support',
		description:
			'Our team is here to assist you at every step, from integration to optimization.',
	},
	{
		name: 'Multi-format Question Support',
		description:
			'Support for various question formats including multiple-choice, true/false, short answer, and more, accommodating diverse assessment needs and preferences.',
	},
	{
		name: 'Boards',
		description:
			'TN board, CBSE board, ICSE board, and more. We have questions for all major boards in India.',
	},
	{
		name: 'Math Formulas',
		description:
			'Beautifully rendered math formulas to help you create engaging math questions.',
	},
	{
		name: 'NEET, JEE, and More',
		description:
			'Get access to questions from all major competitive exams in India, including NEET, JEE, and more.',
	},
]

export default function Features() {
	return (
		<div className=" py-24 sm:py-32">
			<div className="container px-6 lg:px-8">
				<div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
					<div>
						<h2 className="text-base font-semibold leading-7 text-indigo-600">
							Easy Integration
						</h2>
						<p className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">
							All-in-one platform
						</p>
						<p className="mt-6 text-base leading-7 ">
							Our API is designed for simplicity. With just a few lines of code,
							you can seamlessly integrate a dynamic question bank into your
							platform. We provide detailed documentation and developer support
							to ensure a smooth integration process.
						</p>
					</div>
					<dl className="col-span-2 grid grid-cols-1 gap-x-8 gap-y-10 text-base leading-7  sm:grid-cols-2 lg:gap-y-16">
						{features.map(feature => (
							<div key={feature.name} className="relative pl-9">
								<dt className="font-semibold">
									<CheckIcon
										className="absolute left-0 top-1 h-5 w-5 text-indigo-500"
										aria-hidden="true"
									/>
									{feature.name}
								</dt>
								<dd className="mt-2">{feature.description}</dd>
							</div>
						))}
					</dl>
				</div>
			</div>
		</div>
	)
}
